import React, { FC } from 'react';

import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const CheckIcon: FC<Props> = props => <AbstractIcon {...props} icon={faCheck} />;

export { CheckIcon };